<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import communicationAPI from "@/services/standards/communication/communicationAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import unsafeReportAPI from "@/services/standards/communication/unsafeReportAPI.js";
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Mecanismo de comunicación, auto reporte del SG SST",
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "2.8.1 Mecanismo de comunicación, auto reporte del SG SST ",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Mecanismo de comunicación, auto reporte del SG SST",
          active: true,
        },
      ],

      unsafe: {
        condition: null,
        file: null,
        type_document_cm_id: 2,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      evidence: {
        condition: null,
        file: null,
        type_document_cm_id: 1,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      healt: {
        contact: null,
        health_condition: null,
        file: null,
        type_document_cm_id: 3,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,

      loading: true,

      itemData: null,
      file: null,
      submitted: false,
      deleteCount: 0,
      lastUnsafeId: 1,
      lastHealtId: 1,
      lastEvidenceId: 1,
      nit: this.$store.getters["company/getCompany"].nit || null,

      item: null,
      itemStatus: "No cumplido",

      selected: '',
      usersList: [],
      lista: [],
      lista1: [],
      lista2: [],
      lista3: [],
      mostrar: [],
    };
  },
  methods: {

    goBack() {
      // "Cancelar": descarta lo diligenciado y deja el formulario limpio (equivale a recargar la página)
      window.location.reload();
    },

    getItemData() {
      ItemAPI.getItems(19)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getList() {
      communicationAPI.getAll()
        .then((response) => {
          const datos = (response && response.data && response.data.data) ? response.data.data : [];
          this.lista = datos;
          if (datos.length && datos[0] && datos[0].id) {
            this.mostrar = datos[0].id;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_MECANISMOS_COMUNICACION_AUTORREPORTE.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 19)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
        const itemChange = {
          companies_id: this.companyID,
          item_id: 19,
          status: itemStatus,
        };
        newScoresAPI.calculateScores(itemChange)
          .then((response) => {
            Swal.fire({
              title: "¡Éxito!",
              text: "¡Se ha cambiado el estado del ítem con éxito!",
              icon: "success",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            setTimeout(() => window.location.reload(), 2000)
          })
          .catch((error) => {
            Swal.fire({
              title: "¡ERROR!",
              text: "¡No se ha actualizado el estado del ítem!",
              icon: "error",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });

            setTimeout(() => window.location.reload(), 2000)
            console.log(error);
          });
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          const company = (response && response.data && response.data.company) ? response.data.company : (response && response.data) ? response.data : response;
          const companyId = company && company.id ? company.id : (response && response.id ? response.id : this.companyID);
          return EmployeeAPI.getEmployeesOcupationalMedical(companyId);
        })
        .then((res) => {
          const employees = res && res.employee ? res.employee : [];
          this.usersList = Array.isArray(employees) ? employees : [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument3() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.8.1/Reporte_salud/${this.lastHealtId}/${this.healt.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.8.1/Reporte_salud/${this.lastHealtId}/${this.healt.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.healt.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument2() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.8.1/Reporte_condicion/${this.lastUnsafeId}/${this.unsafe.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.8.1/Reporte_condicion/${this.lastUnsafeId}/${this.unsafe.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.unsafe.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument1() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.8.1/Evidencia_comunicaciones/${this.lastEvidenceId}/${this.evidence.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.8.1/Evidencia_comunicaciones/${this.lastEvidenceId}/${this.evidence.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.evidence.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save1() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument1();
      if (response) {
        unsafeReportAPI.save3(this.evidence)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 19,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload()
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    async save2() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument2();
      if (response) {
        unsafeReportAPI.save(this.unsafe)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 19,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    tye: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload()
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "Error!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    async save3() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument3();
      if (response) {
        unsafeReportAPI.save2(this.healt)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 19,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload()
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getList1() {
      unsafeReportAPI.getAllEvidence(this.companyID)
        .then((response) => {
          const datos = (response && response.data && response.data.data) ? response.data.data : [];
          this.lista1 = datos;
          if (datos.length && datos[0] && datos[0].id) {
            this.lastEvidenceId = datos[0].id + 1;
          }
          this.deleteCount = Array.isArray(datos) ? datos.length : 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList2() {
      unsafeReportAPI.getAllunsafe(this.companyID)
        .then((response) => {
          const datos = (response && response.data && response.data.data) ? response.data.data : [];
          this.lista2 = datos;
          if (datos.length && datos[0] && datos[0].id) {
            this.lastUnsafeId = datos[0].id + 1;
          }
          this.deleteCount = Array.isArray(datos) ? datos.length : 0;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getList3() {
      unsafeReportAPI.getAllhealt(this.companyID)
        .then((response) => {
          const datos = (response && response.data && response.data.data) ? response.data.data : [];
          this.lista3 = datos;
          if (datos.length && datos[0] && datos[0].id) {
            this.lastHealtId = datos[0].id + 1;
          }
          this.deleteCount = Array.isArray(datos) ? datos.length : 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },
  mounted() {
    this.getList()
    this.getList1()
    this.getList2()
    this.getList3()
    this.getUsers()
    this.getItemData();
    this.getItems();
    // Garantizar que loading se desactive después de 5 segundos como fallback
    setTimeout(() => {
      this.loading = false;
    }, 5000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">

      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Se debe disponer de mecanismos eficaces para el manejo de las comunicaciones relacionadas con el
                      SG SST tanto internas como externas.
                    </p>
                    <p class="text-justify">
                      Para el manejo de las comunicaciones se pueden utilizar los diferentes mecanismos dispuestos por
                      la empresa: Carteleras, capacitaciones, correos electrónicos, entre otros, lo invitamos a
                      revisar la información aportada para este punto, el responsable de la implementación debe subir
                      las evidencias de las comunicaciones realizadas. Así mismo, se establece un formato para que
                      cada uno de los colaboradores reporte los actos y condiciones inseguras o condiciones de salud,
                      posteriormente el responsable de la implementación, debe subir los registros de estos reportes
                      para garantizar la trazabilidad.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <div class="col-12 px-2 d-flex justify-content-end align-items-center flex-wrap">
                <router-link class="mr-2" to="/forms/mecanismo-comunicacion">Mecanismo de comunicaciones</router-link>
                <router-link
                  :to="`/forms/estandares/${companyID}/informe-autorreportes`"
                  class="btn btn-outline-primary px-2 mr-2"
                >
                  <i class="mdi mdi-chart-box-outline"></i> Informe resumen de reportes
                </router-link>
                <button class="btn btn-primary px-2" @click="print">Descargar formato de mecanismos de
                  comunicación y autorreporte</button>
                <b-tooltip target="tooltip" placement="left">
                  Descargar formato
                </b-tooltip>
              </div>

              <div class="form-row pt-3">
                <b-form-group label-for="lista" class="col-md-6 px-2" label="Tipo de archivo a reportar">
                  <select :disabled="!allowAccess() || !getRole('Crear')" v-model="selected" required
                    class="form-control">

                    <b-form-select-option v-for="item in lista" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
              </div>
              <hr>

              <div v-if="selected == 1">
                <br>
                <h4>Evidencia de comunicaciones</h4>
                <form class="form-group" @submit.prevent="save1">
                  <div class="form-row pt-3">

                    <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                      <select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control"
                        v-model="evidence.employee_id">
                        <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                          {{ item.full_name }}
                        </b-form-select-option>
                      </select>
                    </b-form-group>

                    <b-form-group class="col-md-6 px-2" label="Elemento que se comunico" label-for="date_exam">
                      <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" id="elemento"
                        v-model="evidence.contact">
                      </b-form-input>
                    </b-form-group>

                    <b-form-group class="col-md-6 px-2" label="Subir archivo de envidencia de comunicación"
                      label-for="file">
                      <b-form-file :disabled="!allowAccess() || !getRole('Crear')" required type="file" id="file"
                        ref="file" name="file" browse-text="Buscar" v-model="file" @change="uploadFile"
                        v-on:change="uploadFile" :placeholder="`Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..."
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                      </b-form-file>
                    </b-form-group>
                  </div>

                  <div class="form-group text-right m-b-0">
                    <button :disabled="submitted" type="submit" class="btn btn-primary ">Guardar</button>
                    <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                  </div>

                  <hr />

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card-body">
                        <div class="row pb-3">
                          <div class="col-6">
                            <form class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" class="form-control px-2"
                                  placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                          <div class="col-6"></div>
                        </div>

                        <div class="table-responsive">

                          <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded ">
                            <thead>
                              <tr>
                                <th class="text-center align-middle">Elemento que se comunico</th>
                                <th class="text-center align-middle">Archivo</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in lista1" :key="dato.id">
                                <td class="text-center align-middle">
                                  {{ dato.contact }}
                                </td>

                                <td class="text-center align-middle">
                                  <div v-if="dato.file === null">
                                    <h6>No hay archivo disponible
                                    </h6>
                                  </div>
                                  <div v-else>
                                    <button style=" background-color: transparent !important; border: none;"
                                      type="button" @click="gotoDigitalOcean(`${dato.file}`)"> <i
                                        class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <b-dropdown variant="primary">
                                      <template v-slot:button-content>
                                        <i class="mdi mdi-eye"></i>
                                      </template>
                                      <b-dropdown-item
                                        :to="{ path: `/forms/estandares/evidencia-comunicaciones-editar/${dato.id}` }">
                                        Editar</b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </td>

                              </tr>

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>

                </form>
              </div>

              <div v-if="selected == 2"><br>
                <h4>Reporte de condición insegura</h4>
                <form class="form-group" @submit.prevent="save2">
                  <div class="form-row pt-3">
                    <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                      <select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control"
                        v-model="unsafe.employee_id">
                        <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                          {{ item.full_name }}
                        </b-form-select-option>
                      </select>
                    </b-form-group>

                    <b-form-group class="col-md-6 px-2" label="Subir archivo de reporte" label-for="file">
                      <b-form-file :disabled="!allowAccess() || !getRole('Crear')" required type="file" id="file"
                        ref="file" name="file" browse-text="Buscar" v-model="file" @change="uploadFile"
                        v-on:change="uploadFile" :placeholder="`Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..."
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                      </b-form-file>
                    </b-form-group>

                    <b-form-group label-for="condicion" class="col-md-6 px-2" label="Condición">
                      <select required :disabled="!allowAccess() || !getRole('Crear')" class="form-control"
                        v-model="unsafe.condition">
                        <b-form-select-option value="1">
                          Reporte de condición insegura
                        </b-form-select-option>
                        <b-form-select-option value="2">
                          Reporte de condición de salud
                        </b-form-select-option>
                      </select>
                    </b-form-group>

                  </div>

                  <div class="form-group text-right m-b-0">
                    <button :disabled="submitted" type="submit" class="btn btn-primary ">Guardar</button>
                    <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                  </div>

                  <hr />

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card-body">
                        <div class="row pb-3">
                          <div class="col-6">
                            <form class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" class="form-control px-2"
                                  placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                          <div class="col-6"></div>
                        </div>

                        <div class="table-responsive">
                          <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded ">
                            <thead>
                              <tr>
                                <th class="text-center align-middle">Colaborador</th>
                                <th class="text-center align-middle">Reporte condición</th>
                                <th class="text-center align-middle">Archivo</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in lista2" :key="dato.id">
                                <td class="text-center align-middle">
                                  {{ dato.full_name }}
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.type_document_cm_id == 3">
                                    Reporte de condición de salud
                                  </div>
                                  <div v-if="dato.type_document_cm_id == 2">
                                    Reporte de condición insegura
                                  </div>
                                  <div v-if="dato.type_document_cm_id == 1">
                                    Evidencia de comunicaciones
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.file === null">
                                    <h6>No hay archivo disponible
                                    </h6>
                                  </div>
                                  <div v-else>
                                    <button style=" background-color: transparent !important; border: none;"
                                      type="button" @click="gotoDigitalOcean(`${dato.file}`)"> <i
                                        class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <b-dropdown variant="primary">
                                      <template v-slot:button-content>
                                        <i class="mdi mdi-eye"></i>
                                      </template>
                                      <b-dropdown-item
                                        :to="{ path: `/forms/estandares/reporte-condicion-editar/${dato.id}` }">
                                        Editar</b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </td>

                              </tr>

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- end col -->

                </form>

              </div>

              <div v-if="selected == 3"><br>
                <h4>Reporte de condición de salud</h4>
                <form class="form-group" @submit.prevent="save3">
                  <div class="form-row pt-3">
                    <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                      <select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control"
                        v-model="healt.employee_id">
                        <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                          {{ item.full_name }}
                        </b-form-select-option>
                      </select>
                    </b-form-group>

                    <b-form-group class="col-md-6 px-2" label="Subir archivo de reporte" label-for="file">
                      <b-form-file :disabled="!allowAccess() || !getRole('Crear')" required type="file" id="file"
                        ref="file" name="file" browse-text="Buscar" v-model="file" @change="uploadFile"
                        v-on:change="uploadFile" :placeholder="`Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..."
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                      </b-form-file>
                    </b-form-group>

                    <b-form-group label-for="condicion" class="col-md-6 px-2" label="Condición">
                      <select required :disabled="!allowAccess() || !getRole('Crear')" class="form-control"
                        v-model="healt.contact">
                        <b-form-select-option value="1">
                          Reporte de condición insegura
                        </b-form-select-option>
                        <b-form-select-option value="2">
                          Reporte de condición de salud
                        </b-form-select-option>
                      </select>
                    </b-form-group>

                    <b-form-group label-for="health_condition" class="col-md-6 px-2"
                      label="Descripción de la condición de salud reportada">
                      <textarea :disabled="!allowAccess() || !getRole('Crear')" required class="form-control"
                        id="health_condition" v-model="healt.health_condition" rows="2"></textarea>
                    </b-form-group>

                  </div>

                  <div class="form-group text-right m-b-0">
                    <button :disabled="submitted" type="submit" class="btn btn-primary ">Guardar</button>
                    <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                  </div>

                  <hr />

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card-body">
                        <div class="row pb-3">
                          <div class="col-6">
                            <form class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" class="form-control px-2"
                                  placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                          <div class="col-6"></div>
                        </div>

                        <div class="table-responsive">

                          <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded ">
                            <thead>
                              <tr>
                                <th class="text-center align-middle">Colaborador</th>
                                <th class="text-center align-middle">Reporte condición</th>
                                <th class="text-center align-middle">Archivo</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in lista3" :key="dato.id">
                                <td class="text-center align-middle">
                                  {{ dato.full_name }}
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.type_document_cm_id == 3">
                                    Reporte de condición de salud
                                  </div>
                                  <div v-if="dato.type_document_cm_id == 2">
                                    Reporte de condición insegura
                                  </div>
                                  <div v-if="dato.type_document_cm_id == 1">
                                    Evidencia de comunicaciones
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.file === null">
                                    <h6>No hay archivo disponible
                                    </h6>
                                  </div>
                                  <div v-else>
                                    <button style=" background-color: transparent !important; border: none;"
                                      type="button" @click="gotoDigitalOcean(`${dato.file}`)"> <i
                                        class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <b-dropdown variant="primary">
                                      <template v-slot:button-content>
                                        <i class="mdi mdi-eye"></i>
                                      </template>
                                      <b-dropdown-item
                                        :to="{ path: `/forms/estandares/reporte-condicion-salud-editar/${dato.id}` }">
                                        Editar</b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </td>

                              </tr>

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- end col -->

                </form>

              </div>

            </div>
          </div>
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        
      </div>
    </div>
  </Layout>
</template>
